import { render, staticRenderFns } from "./FormChangeCoverageArea.vue?vue&type=template&id=3d5859ee&"
import script from "./FormChangeCoverageArea.vue?vue&type=script&lang=js&"
export * from "./FormChangeCoverageArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports